// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Laptop: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 51"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M6.1 41.2h.8c.6 0 1-.4 1-1V4.7c0-.4.4-.9.9-.9h47.5c.5 0 .9.4.9 1v35.5c0 .6.4 1 1 1h.8c.6 0 1-.4 1-1V4.8c0-2-1.6-3.7-3.6-3.7H8.7c-2 0-3.6 1.6-3.6 3.6v35.5c0 .6.4 1 1 1z"/><path d="M10.6 5.6c-.6 0-1 .4-1 1V40c0 .6.4 1 1 1h43.8c.6 0 1-.4 1-1V6.6c0-.6-.4-1-1-1H10.6zm42.1 2.7v29.9H12.3V8.3h40.4zm11.6 34.8c-.2-.3-.5-.4-.9-.4H1.6c-.6 0-1 .5-1 1.1v.1c.1.2 1.3 6 4.6 6h54.6c3.5 0 4.5-5.8 4.6-5.9.1-.3 0-.6-.1-.9zm-3.1 2.4c-.3.8-.9 1.7-1.4 1.7H5.2c-.2-.1-.7-.8-1.2-1.7h57.2z"/></svg>;
};

export default React.memo(Laptop);
